import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material"
import { Trans, useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useSearchParams } from "react-router-dom";

import { theme } from "../../utils";

import { TabsComponent } from "./components";
import AboutGA from "./aboutGA";
import { Resources } from "./resources";
import Management from "./management";
import Imaging from "./imaging";
import TransMsg from "./transMessage";
import videoURL from '../../assets/videos/bannerVideo.webm'
import MobileBannerImg from '../../assets/images/other/banner_mobile.png'
import {BreadCrumb} from "../../components";

const styles = {
    mainWrapper: {
        backgroundColor: "#1E1E22",
        paddingTop: "22px",
        paddingBottom: "31px",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    },
    bannerTitle: {
        ...theme.typography.opticianBodyRegular,
        fontSize: "40px",
        lineHeight: "100%",
        color: "#fff",
        textTransform: "uppercase",
        mt: "1rem"
    },
    bannerDescription: {
        ...theme.typography.poppinsBodyRegular,
        fontSize: "1rem",
        color: "#fff",
        mt: "1rem"
    },
    tabSx: {
        border: "2px solid #4B69F1",
        borderRadius: 200,
        '& .MuiTab-root': {
            textTransform: "capitalize",
            ...theme.typography.body1SemiBold,
            color: "#fff"
        },
        '& .MuiTabs-indicator': {
            backgroundColor: "#1E1E22",
        },
        '& .MuiTabs-list': {
            backgroundColor: "#1E1E22",
            gap: "100px",
            px: "36px"
        },
        '& .MuiTab-root.Mui-selected': {
            backgroundColor: "#4B69F1",
            margin: "10px",
            borderRadius: 200,
            color: "#fff",
            width: "180px"
        }
    }
}
export const EducationHub = () => {
    const { t } = useTranslation()
    const isMobile = useMediaQuery(theme.breakpoints.down(950))
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    const [searchParams] = useSearchParams();
    const tabPath: any = searchParams.get("tabPath");

    const [educationHubTabValue, setEducationHubTabValue] = useState(0);

    useEffect(() => {
        if (tabPath === '2') {
            setEducationHubTabValue(1)
        }
        window.scrollTo(0, 0)
    }, [tabPath])

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setEducationHubTabValue(newValue);
    };

    const crumbPath = [{ name: "Home", url: "/home" }, { name: "Education Hub", url: "/education-hub" }]
    const educationHubTabs = [
        {
            tabLabel: t(TransMsg.ABOUT_GA_LABEL),
            children: <AboutGA />
        },
        {
            tabLabel: t(TransMsg.IMAGING_LABEL),
            children: <Imaging />
        },
        {
            tabLabel: t(TransMsg.MANAGEMENT_LABEL),
            children: <Management />
        },
        {
            tabLabel: t(TransMsg.RESOURCES_LABEL),
            children: <Resources />
        },
    ]
    return (
        <Box>
            <Box sx={styles.mainWrapper} textAlign={"left"}>
                <Box flex={1} display={"flex"} justifyContent={"space-between"} flexWrap={"wrap"} gap={"16px"}>
                    <Box sx={{ pt: "44px", mt:'40px', pl: isMobile ? "31px" : "148px", pr: "80px" }} flex={1}>
                        <BreadCrumb breadCrumbPath={crumbPath} sx={{ color: "#fff" }} linkSx={{ color: "#fff" }} />
                        <Typography sx={styles.bannerTitle}>
                            <Trans
                                i18nKey={t(TransMsg.BANNER_TITLE)}
                                components={{ br: <br /> }} />
                        </Typography>
                        <Typography sx={styles.bannerDescription}>
                            <Trans
                                i18nKey={t(TransMsg.BANNER_DESCRIPTION)}
                                components={{ br: <br /> }}
                            />
                        </Typography>
                    </Box>
                    <Box sx={{ pr: "88px", ml: "31px" }}>
                        <Box sx={{ maxWidth: "466px", maxHeight: "292px", overflow: "hidden", position: 'relative' }}>
                            {isMobileX ?
                                <img src={MobileBannerImg} style={{ height: "450px", width: "350px", marginLeft: "30px", marginTop: "20px" }} alt="Mobile-Banner-Img" />
                                :
                                <>
                                    <ReactPlayer
                                        url={videoURL}
                                        controls={false}
                                        loop
                                        playing
                                        width={"100%"}
                                        height={"100%"}
                                        style={{
                                            objectFit: 'cover'
                                        }}
                                        playsinline={true}
                                        muted={true}
                                    />
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "76%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            width: "400px",
                                            height: "400px",
                                            backgroundColor: "#C7D8E5",
                                            borderRadius: "50%",
                                            mixBlendMode: "color",
                                            pointerEvents: "none"
                                        }}
                                    />
                                </>
                            }
                        </Box>

                    </Box>
                </Box>
            </Box>
            <TabsComponent
                value={educationHubTabValue}
                handleChange={handleChange}
                tabsList={educationHubTabs}
                tabWrapperSx={{ backgroundColor: "#1E1E22", paddingBottom: "30px" }}
                tabsSx={styles.tabSx}
            />
        </Box>
    )
}